"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTemplatesTab = void 0;
const React = require("react");
const filter_header_1 = require("client/components/filter-header");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const po_distributor_email_template_1 = require("shared/po-distributor-email-template");
const store_2 = require("client/modules/inventory-order/store");
const material_ui_1 = require("material-ui");
const throttle_debounce_1 = require("throttle-debounce");
require("./order-templates.less");
const columns = [
    {
        label: "Distributor",
        id: "distributor"
    },
    {
        label: "Template Name",
        id: "template"
    },
    {
        label: "Created Date",
        id: "date"
    },
    {
        label: "Creator",
        id: "creator"
    }
];
let OrderTemplatesTab = class OrderTemplatesTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.order = "";
        this.filterText = "";
        this.orderBy = "";
        this.approvedAndUnsentPurchaseOrders = [];
        this.loadPurchaseOrders = throttle_debounce_1.debounce(200, async () => {
            await store_2.inventoryOrderStore.loadPurchaseOrders({
                count: 100,
                order: this.order,
                search: this.filterText,
                sort: this.orderBy,
                start: 0,
                siteId: 34,
                approved: true,
                mailMessagesNotSent: true
            });
            this.approvedAndUnsentPurchaseOrders = store_2.inventoryOrderStore.purchaseOrders;
        });
        this.parseAndSendOrder = async (purchaseOrder) => {
            const orderInventoryDistributors = {};
            // Map out distributor object with values as inventories related to that distributor.
            for (const inventory of purchaseOrder.orderInventories) {
                if (inventory.distributor) {
                    if (orderInventoryDistributors.hasOwnProperty(inventory.distributor)) {
                        orderInventoryDistributors[inventory.distributor] = [
                            ...orderInventoryDistributors[inventory.distributor],
                            inventory
                        ];
                    }
                    else {
                        orderInventoryDistributors[inventory.distributor] = [inventory];
                    }
                }
            }
            // console.log("orderInventoryDistributor is ", orderInventoryDistributors);
            const emailTemplates = {};
            // Map out email template organized by distributors.
            for (const distributor in orderInventoryDistributors) {
                if (orderInventoryDistributors.hasOwnProperty(distributor)) {
                    const distributorInventories = orderInventoryDistributors[distributor].map((inventory) => ({
                        id: inventory.id,
                        poNumber: purchaseOrder.id,
                        name: inventory.name,
                        pkgCode: inventory.pkgCode,
                        inventoryOrderQuantity: inventory.inventoryOrderQuantity,
                        price: inventory.price,
                        inventoryTotalCost: inventory.inventoryTotalCost,
                    }));
                    const inventoryTable = po_distributor_email_template_1.buildDistributorPOTable(distributorInventories);
                    const subject = "Purchase order request";
                    const title = `Purchase order for ${distributor}`; //C-022.15
                    const body = inventoryTable;
                    const distributorOrderEmailTemplate = po_distributor_email_template_1.getDistributorPOEmailTemplate(subject, title, body);
                    emailTemplates[distributor] = distributorOrderEmailTemplate.trim();
                }
            }
            const distributorOrders = {
                purchaseOrder,
                siteId: 1,
                emailTemplates,
                orderInventoryDistributors
            };
            await store_2.inventoryOrderStore.sendEmailOrderToDistributors(distributorOrders);
        };
        this.handleTestEmailToDistributor = () => {
            for (const purchaseOrder of this.approvedAndUnsentPurchaseOrders) {
                this.parseAndSendOrder(purchaseOrder);
            }
        };
        this.onCallback = () => {
            alert("oncallback");
        };
    }
    componentDidMount() {
        this.loadPurchaseOrders();
    }
    render() {
        return (React.createElement("div", { className: "inventory-order__order-templates" },
            React.createElement(material_ui_1.Typography, { variant: "display1" }, "Order templates"),
            store_1.usersStore.permissions.UpdateTemplates && (React.createElement("div", { className: "order-templates__button" },
                React.createElement(button_1.MaterialButton, { variant: "flat" }, "Add template"))),
            React.createElement(filter_header_1.FilterHeader, { label: "Search", title: "Purchase Order Template", callBack: this.onCallback, filterText: "" }),
            React.createElement(list_1.MaterialList, { columns: columns, order: "ASC", orderBy: "", rows: [], renderRow: true })));
    }
};
__decorate([
    mobx_1.observable
], OrderTemplatesTab.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], OrderTemplatesTab.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], OrderTemplatesTab.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], OrderTemplatesTab.prototype, "approvedAndUnsentPurchaseOrders", void 0);
OrderTemplatesTab = __decorate([
    mobx_react_1.observer
], OrderTemplatesTab);
exports.OrderTemplatesTab = OrderTemplatesTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-templates/order-templates.tsx
// module id = 3596
// module chunks = 0